import { render, staticRenderFns } from "./AssociatedSites.vue?vue&type=template&id=31e15acf"
import script from "./AssociatedSites.vue?vue&type=script&lang=js"
export * from "./AssociatedSites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports